import { EditLocation } from "@material-ui/icons";
import React from "react";

export function Cross() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="43"
        height="43"
        rx="21.5"
        fill="white"
        stroke="#F5F1FE"
      />
      <path
        d="M16 27.3723C16.0292 27.3833 16.0183 27.4125 16.0256 27.4308C16.2009 28.0045 16.8949 28.1909 17.3222 27.7743C17.7313 27.376 18.1294 26.9703 18.5312 26.5647C19.6561 25.4392 20.7847 24.3136 21.9097 23.1808C21.9827 23.1077 22.0156 23.1114 22.0887 23.1808C23.6008 24.701 25.1166 26.2139 26.6323 27.7304C26.9428 28.0411 27.3519 28.0813 27.6806 27.8401C28.0495 27.5697 28.1079 27.0507 27.8084 26.7036C27.7755 26.6634 27.739 26.6305 27.7025 26.5939C26.2013 25.092 24.7002 23.5901 23.1954 22.0881C23.1223 22.015 23.1077 21.9785 23.1917 21.8981C24.7075 20.3889 26.2196 18.8723 27.7317 17.3594C28.0312 17.0598 28.0824 16.6651 27.8705 16.3399C27.7573 16.1681 27.5929 16.0767 27.4103 16C27.2861 16 27.1619 16 27.0341 16C26.8624 16.0183 26.7309 16.1096 26.6141 16.2266C25.1202 17.7248 23.6227 19.2195 22.1288 20.7141C22.1033 20.7397 22.0777 20.7616 22.0558 20.7872C22.0193 20.8274 21.9827 20.8274 21.9462 20.7872C21.9206 20.7616 21.8951 20.736 21.8732 20.7141C20.372 19.2268 18.8745 17.7322 17.3806 16.2339C17.2638 16.1133 17.1323 16.0256 16.9606 16.0073C16.8364 16.0073 16.7122 16.0073 16.5844 16.0073C16.2484 16.0767 16.0621 16.2887 16 16.6176C16 16.7199 16 16.8222 16 16.9209C16.0146 17.1146 16.1205 17.2571 16.252 17.3923C17.7495 18.8869 19.2434 20.3816 20.7409 21.8798C20.7811 21.92 20.8213 21.9675 20.8724 21.9968C20.8286 22.0224 20.7957 22.0626 20.7592 22.0954C19.258 23.5937 17.7568 25.0957 16.2557 26.5976C16.1242 26.7292 16.0183 26.8717 16 27.069C16 27.1713 16 27.27 16 27.3723Z"
        fill="#363636"
      />
    </svg>
  );
}

export function DashboardIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 3C4.34315 3 3 4.34315 3 6V8C3 9.65685 4.34315 11 6 11H8C9.65685 11 11 9.65685 11 8V6C11 4.34315 9.65685 3 8 3H6ZM16 3C14.3431 3 13 4.34315 13 6V8C13 9.65685 14.3431 11 16 11H18C19.6569 11 21 9.65685 21 8V6C21 4.34315 19.6569 3 18 3H16ZM3 16C3 14.3431 4.34315 13 6 13H8C9.65685 13 11 14.3431 11 16V18C11 19.6569 9.65685 21 8 21H6C4.34315 21 3 19.6569 3 18V16ZM16 13C14.3431 13 13 14.3431 13 16V18C13 19.6569 14.3431 21 16 21H18C19.6569 21 21 19.6569 21 18V16C21 14.3431 19.6569 13 18 13H16Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function User() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
        fill="#899CA8"
      />
      <path
        d="M14.08 14.15C11.29 12.29 6.73996 12.29 3.92996 14.15C2.65996 15 1.95996 16.15 1.95996 17.38C1.95996 18.61 2.65996 19.75 3.91996 20.59C5.31996 21.53 7.15996 22 8.99996 22C10.84 22 12.68 21.53 14.08 20.59C15.34 19.74 16.04 18.6 16.04 17.36C16.03 16.13 15.34 14.99 14.08 14.15Z"
        fill="#899CA8"
      />
      <path
        d="M19.9899 7.33998C20.1499 9.27998 18.7699 10.98 16.8599 11.21C16.8499 11.21 16.8499 11.21 16.8399 11.21H16.8099C16.7499 11.21 16.6899 11.21 16.6399 11.23C15.6699 11.28 14.7799 10.97 14.1099 10.4C15.1399 9.47998 15.7299 8.09998 15.6099 6.59998C15.5399 5.78998 15.2599 5.04998 14.8399 4.41998C15.2199 4.22998 15.6599 4.10998 16.1099 4.06998C18.0699 3.89998 19.8199 5.35998 19.9899 7.33998Z"
        fill="#899CA8"
      />
      <path
        d="M21.9902 16.59C21.9102 17.56 21.2902 18.4 20.2502 18.97C19.2502 19.52 17.9902 19.78 16.7402 19.75C17.4602 19.1 17.8802 18.29 17.9602 17.43C18.0602 16.19 17.4702 15 16.2902 14.05C15.6202 13.52 14.8402 13.1 13.9902 12.79C16.2002 12.15 18.9802 12.58 20.6902 13.96C21.6102 14.7 22.0802 15.63 21.9902 16.59Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Role() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
        fill="#899CA8"
      />
      <path
        d="M17.08 14.15C14.29 12.29 9.73996 12.29 6.92996 14.15C5.65996 15 4.95996 16.15 4.95996 17.38C4.95996 18.61 5.65996 19.75 6.91996 20.59C8.31996 21.53 10.16 22 12 22C13.84 22 15.68 21.53 17.08 20.59C18.34 19.74 19.04 18.6 19.04 17.36C19.03 16.13 18.34 14.99 17.08 14.15Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Marketing() {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.69632 15.9166C3.00984 15.8975 2.44441 15.626 2.08836 15.0327C1.45041 13.9706 0.825546 12.9002 0.229036 11.8141C-0.247518 10.9471 0.0447392 9.85169 0.886615 9.33697C1.85663 8.74428 2.84954 8.18975 3.83591 7.62378C4.06055 7.4951 4.22904 7.56707 4.38334 7.83424C5.0949 9.06652 5.80592 10.2993 6.51748 11.5316C6.55128 11.5905 6.584 11.6516 6.62653 11.7039C6.73503 11.8375 6.92642 11.874 7.06764 11.7852C7.21759 11.6908 7.27538 11.5518 7.21759 11.3811C7.18978 11.2983 7.14289 11.2214 7.09872 11.145C6.39152 9.91821 5.68323 8.69193 4.97549 7.46511C4.79501 7.15267 4.82009 7.02454 5.11671 6.81571C7.45205 5.17012 9.38225 3.13904 10.9231 0.733917C11.5682 -0.273171 12.8855 -0.236639 13.4848 0.798803C15.0769 3.55071 16.6658 6.3048 18.2536 9.05998C18.8463 10.0883 18.2416 11.2197 17.0562 11.3201C16.3032 11.3839 15.5475 11.4318 14.7994 11.5344C12.8179 11.8064 10.9199 12.3762 9.09654 13.1968C7.67724 13.8359 6.38171 14.6985 5.02729 15.4542C4.61017 15.687 4.20341 15.94 3.69632 15.9166Z"
        fill="#899CA8"
      />
      <path
        d="M7.90255 20C7.50397 19.9482 7.173 19.8021 6.97562 19.4711C6.39383 18.4962 5.83003 17.5104 5.26569 16.5251C5.15501 16.3315 5.21226 16.1532 5.41019 16.0376C6.10321 15.633 6.79786 15.2323 7.4947 14.8342C7.70899 14.7121 7.88619 14.7612 8.01269 14.9793C8.56504 15.9324 9.12011 16.8839 9.65828 17.8446C9.95926 18.3817 9.78478 19.0185 9.26678 19.3457C9.00288 19.5125 8.73243 19.6729 8.45326 19.8119C8.28151 19.8986 8.08685 19.9395 7.90255 20Z"
        fill="#899CA8"
      />
      <path
        d="M17.7344 5.15982C17.7273 5.23452 17.7256 5.35775 17.7027 5.47716C17.6733 5.63147 17.5692 5.75579 17.4165 5.75034C17.2982 5.74652 17.1302 5.686 17.0746 5.59494C16.6651 4.92209 16.2769 4.23671 15.8854 3.55295C15.8052 3.41282 15.8336 3.27378 15.9405 3.15764C16.0555 3.03278 16.1973 3.02515 16.3521 3.08131C17.1569 3.37193 17.7393 4.2258 17.7344 5.15982Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Payment() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0336 3.25C15.4053 3.25 16.4807 3.24999 17.3451 3.32061C18.2252 3.39252 18.9523 3.54138 19.6104 3.87671C20.6924 4.42798 21.572 5.30762 22.1233 6.38955C22.5254 7.17877 22.6643 8.08233 22.7165 9.25H1.28354C1.33571 8.08233 1.47459 7.17877 1.87671 6.38955C2.42798 5.30762 3.30762 4.42798 4.38955 3.87671C5.04769 3.54138 5.77479 3.39252 6.65494 3.32061C7.51929 3.24999 8.59472 3.25 9.96644 3.25H14.0336Z"
        fill="#899CA8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.25227 10.75C1.25 11.1341 1.25 11.548 1.25 11.9942V12.0336C1.25 13.4053 1.24999 14.4807 1.32061 15.3451C1.39252 16.2252 1.54138 16.9523 1.87671 17.6104C2.42798 18.6924 3.30762 19.572 4.38955 20.1233C5.04769 20.4586 5.77479 20.6075 6.65494 20.6794C7.51924 20.75 8.59461 20.75 9.96623 20.75H14.0336C15.4052 20.75 16.4808 20.75 17.3451 20.6794C18.2252 20.6075 18.9523 20.4586 19.6104 20.1233C20.6924 19.572 21.572 18.6924 22.1233 17.6104C22.4586 16.9523 22.6075 16.2252 22.6794 15.3451C22.75 14.4808 22.75 13.4054 22.75 12.0338V11.9942C22.75 11.548 22.75 11.1341 22.7477 10.75H1.25227ZM5.25 17C5.25 16.5858 5.58579 16.25 6 16.25H8C8.41421 16.25 8.75 16.5858 8.75 17C8.75 17.4142 8.41421 17.75 8 17.75H6C5.58579 17.75 5.25 17.4142 5.25 17ZM10.25 17C10.25 16.5858 10.5858 16.25 11 16.25H15C15.4142 16.25 15.75 16.5858 15.75 17C15.75 17.4142 15.4142 17.75 15 17.75H11C10.5858 17.75 10.25 17.4142 10.25 17Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Financing() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2499 8.07996V10.94L10.2399 10.59C9.72992 10.41 9.41992 10.24 9.41992 9.36996C9.41992 8.65996 9.94992 8.07996 10.5999 8.07996H11.2499Z"
        fill="#899CA8"
      />
      <path
        d="M14.58 14.6301C14.58 15.3401 14.05 15.9201 13.4 15.9201H12.75V13.0601L13.76 13.4101C14.27 13.5901 14.58 13.7601 14.58 14.6301Z"
        fill="#899CA8"
      />
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM14.26 12C15.04 12.27 16.08 12.84 16.08 14.63C16.08 16.17 14.88 17.42 13.4 17.42H12.75V18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V17.42H10.89C9.25 17.42 7.92 16.03 7.92 14.33C7.92 13.92 8.25 13.58 8.67 13.58C9.08 13.58 9.42 13.92 9.42 14.33C9.42 15.21 10.08 15.92 10.89 15.92H11.25V12.53L9.74 12C8.96 11.73 7.92 11.16 7.92 9.37C7.92 7.83 9.12 6.58 10.6 6.58H11.25V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V6.58H13.11C14.75 6.58 16.08 7.97 16.08 9.67C16.08 10.08 15.75 10.42 15.33 10.42C14.92 10.42 14.58 10.08 14.58 9.67C14.58 8.79 13.92 8.08 13.11 8.08H12.75V11.47L14.26 12Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Appointment() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7502 3.56V2C16.7502 1.59 16.4102 1.25 16.0002 1.25C15.5902 1.25 15.2502 1.59 15.2502 2V3.5H8.75023V2C8.75023 1.59 8.41023 1.25 8.00023 1.25C7.59023 1.25 7.25023 1.59 7.25023 2V3.56C4.55023 3.81 3.24023 5.42 3.04023 7.81C3.02023 8.1 3.26023 8.34 3.54023 8.34H20.4602C20.7502 8.34 20.9902 8.09 20.9602 7.81C20.7602 5.42 19.4502 3.81 16.7502 3.56Z"
        fill="#899CA8"
      />
      <path
        d="M20 9.83997H4C3.45 9.83997 3 10.29 3 10.84V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V10.84C21 10.29 20.55 9.83997 20 9.83997ZM9.21 18.21C9.16 18.25 9.11 18.3 9.06 18.33C9 18.37 8.94 18.4 8.88 18.42C8.82 18.45 8.76 18.47 8.7 18.48C8.63 18.49 8.57 18.5 8.5 18.5C8.37 18.5 8.24 18.47 8.12 18.42C7.99 18.37 7.89 18.3 7.79 18.21C7.61 18.02 7.5 17.76 7.5 17.5C7.5 17.24 7.61 16.98 7.79 16.79C7.89 16.7 7.99 16.63 8.12 16.58C8.3 16.5 8.5 16.48 8.7 16.52C8.76 16.53 8.82 16.55 8.88 16.58C8.94 16.6 9 16.63 9.06 16.67C9.11 16.71 9.16 16.75 9.21 16.79C9.39 16.98 9.5 17.24 9.5 17.5C9.5 17.76 9.39 18.02 9.21 18.21ZM9.21 14.71C9.02 14.89 8.76 15 8.5 15C8.24 15 7.98 14.89 7.79 14.71C7.61 14.52 7.5 14.26 7.5 14C7.5 13.74 7.61 13.48 7.79 13.29C8.07 13.01 8.51 12.92 8.88 13.08C9.01 13.13 9.12 13.2 9.21 13.29C9.39 13.48 9.5 13.74 9.5 14C9.5 14.26 9.39 14.52 9.21 14.71ZM12.71 18.21C12.52 18.39 12.26 18.5 12 18.5C11.74 18.5 11.48 18.39 11.29 18.21C11.11 18.02 11 17.76 11 17.5C11 17.24 11.11 16.98 11.29 16.79C11.66 16.42 12.34 16.42 12.71 16.79C12.89 16.98 13 17.24 13 17.5C13 17.76 12.89 18.02 12.71 18.21ZM12.71 14.71C12.66 14.75 12.61 14.79 12.56 14.83C12.5 14.87 12.44 14.9 12.38 14.92C12.32 14.95 12.26 14.97 12.2 14.98C12.13 14.99 12.07 15 12 15C11.74 15 11.48 14.89 11.29 14.71C11.11 14.52 11 14.26 11 14C11 13.74 11.11 13.48 11.29 13.29C11.38 13.2 11.49 13.13 11.62 13.08C11.99 12.92 12.43 13.01 12.71 13.29C12.89 13.48 13 13.74 13 14C13 14.26 12.89 14.52 12.71 14.71ZM16.21 18.21C16.02 18.39 15.76 18.5 15.5 18.5C15.24 18.5 14.98 18.39 14.79 18.21C14.61 18.02 14.5 17.76 14.5 17.5C14.5 17.24 14.61 16.98 14.79 16.79C15.16 16.42 15.84 16.42 16.21 16.79C16.39 16.98 16.5 17.24 16.5 17.5C16.5 17.76 16.39 18.02 16.21 18.21ZM16.21 14.71C16.16 14.75 16.11 14.79 16.06 14.83C16 14.87 15.94 14.9 15.88 14.92C15.82 14.95 15.76 14.97 15.7 14.98C15.63 14.99 15.56 15 15.5 15C15.24 15 14.98 14.89 14.79 14.71C14.61 14.52 14.5 14.26 14.5 14C14.5 13.74 14.61 13.48 14.79 13.29C14.89 13.2 14.99 13.13 15.12 13.08C15.3 13 15.5 12.98 15.7 13.02C15.76 13.03 15.82 13.05 15.88 13.08C15.94 13.1 16 13.13 16.06 13.17C16.11 13.21 16.16 13.25 16.21 13.29C16.39 13.48 16.5 13.74 16.5 14C16.5 14.26 16.39 14.52 16.21 14.71Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function SettingsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 12C9.75 10.7574 10.7574 9.75002 12 9.75002C13.2426 9.75002 14.25 10.7574 14.25 12C14.25 13.2427 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2427 9.75 12Z"
        fill="#363636"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.58523 3.2323C9.56564 -0.203083 14.4342 -0.203084 15.4147 3.2323C15.7184 4.2967 16.812 4.92806 17.8857 4.65893C21.351 3.7903 23.7853 8.00664 21.3004 10.5734C20.5305 11.3687 20.5305 12.6314 21.3004 13.4266C23.7853 15.9934 21.351 20.2097 17.8857 19.3411C16.812 19.072 15.7184 19.7033 15.4147 20.7677C14.4342 24.2031 9.56564 24.2031 8.58523 20.7677C8.28146 19.7033 7.18792 19.072 6.11423 19.3411C2.6489 20.2097 0.214599 15.9934 2.69952 13.4266C3.46944 12.6314 3.46944 11.3687 2.69952 10.5734C0.214599 8.00664 2.6489 3.7903 6.11423 4.65893C7.18792 4.92806 8.28146 4.2967 8.58523 3.2323ZM12 8.25002C9.92893 8.25002 8.25 9.92895 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92895 14.0711 8.25002 12 8.25002Z"
        fill="#363636"
      />
    </svg>
  );
}

export function LogoutProfile() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 11.25C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75L15 12.75L15 15C15 15.929 15 16.3935 14.9384 16.7822C14.5996 18.9216 12.9216 20.5996 10.7822 20.9384C10.3935 21 9.929 21 9 21C8.07099 21 7.60649 21 7.21783 20.9384C5.07836 20.5996 3.40041 18.9216 3.06156 16.7822C3 16.3935 3 15.929 3 15L3 9C3 8.07099 3 7.60649 3.06156 7.21783C3.40042 5.07836 5.07837 3.40042 7.21783 3.06156C7.60649 3 8.07099 3 9 3C9.92901 3 10.3935 3 10.7822 3.06156C12.9216 3.40042 14.5996 5.07836 14.9384 7.21783C15 7.60649 15 8.07099 15 9L15 11.25L7 11.25ZM15 11.25L19.8105 11.25C19.483 10.9273 19.001 10.5437 18.297 9.98553L16.534 8.58768C16.2095 8.33034 16.155 7.8586 16.4123 7.53403C16.6697 7.20946 17.1414 7.15497 17.466 7.41232L19.2648 8.83857C19.9372 9.37175 20.4922 9.81172 20.8875 10.2055C21.2932 10.6096 21.6294 11.0582 21.7208 11.6313C21.7402 11.7534 21.75 11.8766 21.75 12C21.75 12.1234 21.7402 12.2466 21.7208 12.3687C21.6294 12.9418 21.2932 13.3904 20.8875 13.7945C20.4922 14.1883 19.9373 14.6282 19.2648 15.1614L17.466 16.5877C17.1414 16.845 16.6697 16.7905 16.4123 16.466C16.155 16.1414 16.2095 15.6697 16.534 15.4123L18.297 14.0145C19.001 13.4563 19.483 13.0727 19.8105 12.75L15 12.75L15 11.25Z"
        fill="#363636"
      />
    </svg>
  );
}

export function Ezpay() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 4H7C4 4 2 5.5 2 9V12.56C2 12.93 2.38 13.16 2.71 13.01C3.69 12.56 4.82 12.39 6.01 12.6C8.64 13.07 10.57 15.51 10.5 18.18C10.49 18.6 10.43 19.01 10.32 19.41C10.24 19.72 10.49 20.01 10.81 20.01H17C20 20.01 22 18.51 22 15.01V9C22 5.5 20 4 17 4ZM12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5ZM19.25 14C19.25 14.41 18.91 14.75 18.5 14.75C18.09 14.75 17.75 14.41 17.75 14V10C17.75 9.59 18.09 9.25 18.5 9.25C18.91 9.25 19.25 9.59 19.25 10V14Z"
        fill="#899CA8"
      />
      <path
        d="M5 14C2.79 14 1 15.79 1 18C1 18.75 1.21 19.46 1.58 20.06C2.27 21.22 3.54 22 5 22C6.46 22 7.73 21.22 8.42 20.06C8.79 19.46 9 18.75 9 18C9 15.79 7.21 14 5 14ZM6.97 17.67L4.84 19.64C4.7 19.77 4.51 19.84 4.33 19.84C4.14 19.84 3.95 19.77 3.8 19.62L2.81 18.63C2.52 18.34 2.52 17.86 2.81 17.57C3.1 17.28 3.58 17.28 3.87 17.57L4.35 18.05L5.95 16.57C6.25 16.29 6.73 16.31 7.01 16.61C7.29 16.91 7.27 17.39 6.97 17.67Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Ezplan() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2499 8.07996V10.94L10.2399 10.59C9.72992 10.41 9.41992 10.24 9.41992 9.36996C9.41992 8.65996 9.94992 8.07996 10.5999 8.07996H11.2499Z"
        fill="#899CA8"
      />
      <path
        d="M14.58 14.6301C14.58 15.3401 14.05 15.9201 13.4 15.9201H12.75V13.0601L13.76 13.4101C14.27 13.5901 14.58 13.7601 14.58 14.6301Z"
        fill="#899CA8"
      />
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM14.26 12C15.04 12.27 16.08 12.84 16.08 14.63C16.08 16.17 14.88 17.42 13.4 17.42H12.75V18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V17.42H10.89C9.25 17.42 7.92 16.03 7.92 14.33C7.92 13.92 8.25 13.58 8.67 13.58C9.08 13.58 9.42 13.92 9.42 14.33C9.42 15.21 10.08 15.92 10.89 15.92H11.25V12.53L9.74 12C8.96 11.73 7.92 11.16 7.92 9.37C7.92 7.83 9.12 6.58 10.6 6.58H11.25V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V6.58H13.11C14.75 6.58 16.08 7.97 16.08 9.67C16.08 10.08 15.75 10.42 15.33 10.42C14.92 10.42 14.58 10.08 14.58 9.67C14.58 8.79 13.92 8.08 13.11 8.08H12.75V11.47L14.26 12Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Administrator() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 12C9.75 10.7574 10.7574 9.75002 12 9.75002C13.2426 9.75002 14.25 10.7574 14.25 12C14.25 13.2427 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2427 9.75 12Z"
        fill="#899CA8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.58523 3.2323C9.56564 -0.203083 14.4342 -0.203084 15.4147 3.2323C15.7184 4.2967 16.812 4.92806 17.8857 4.65893C21.351 3.7903 23.7853 8.00664 21.3004 10.5734C20.5305 11.3687 20.5305 12.6314 21.3004 13.4266C23.7853 15.9934 21.351 20.2097 17.8857 19.3411C16.812 19.072 15.7184 19.7033 15.4147 20.7677C14.4342 24.2031 9.56564 24.2031 8.58523 20.7677C8.28146 19.7033 7.18792 19.072 6.11423 19.3411C2.6489 20.2097 0.214599 15.9934 2.69952 13.4266C3.46944 12.6314 3.46944 11.3687 2.69952 10.5734C0.214599 8.00664 2.6489 3.7903 6.11423 4.65893C7.18792 4.92806 8.28146 4.2967 8.58523 3.2323ZM12 8.25002C9.92893 8.25002 8.25 9.92895 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92895 14.0711 8.25002 12 8.25002Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Content() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 13.15H13.33C11.55 13.15 10.1 11.71 10.1 9.92V7.75C10.1 7.34 9.77 7 9.35 7H6.18C3.87 7 2 8.5 2 11.18V17.82C2 20.5 3.87 22 6.18 22H12.07C14.38 22 16.25 20.5 16.25 17.82V13.9C16.25 13.48 15.91 13.15 15.5 13.15Z"
        fill="#899CA8"
      />
      <path
        d="M17.8198 2H15.8498H14.7598H11.9298C9.66977 2 7.83977 3.44 7.75977 6.01C7.81977 6.01 7.86977 6 7.92977 6H10.7598H11.8498H13.8198C16.1298 6 17.9998 7.5 17.9998 10.18V12.15V14.86V16.83C17.9998 16.89 17.9898 16.94 17.9898 16.99C20.2198 16.92 21.9998 15.44 21.9998 12.83V10.86V8.15V6.18C21.9998 3.5 20.1298 2 17.8198 2Z"
        fill="#899CA8"
      />
      <path
        d="M11.9801 7.14999C11.6701 6.83999 11.1401 7.04999 11.1401 7.47999V10.1C11.1401 11.2 12.0701 12.1 13.2101 12.1C13.9201 12.11 14.9101 12.11 15.7601 12.11C16.1901 12.11 16.4101 11.61 16.1101 11.31C15.0201 10.22 13.0801 8.26999 11.9801 7.14999Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Notification() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1902 14.06L19.0602 12.18C18.8102 11.77 18.5902 10.98 18.5902 10.5V8.63005C18.5902 5.00005 15.6402 2.05005 12.0202 2.05005C8.3902 2.06005 5.4402 5.00005 5.4402 8.63005V10.49C5.4402 10.97 5.2202 11.76 4.9802 12.17L3.8502 14.05C3.4202 14.78 3.3202 15.61 3.5902 16.33C3.8602 17.06 4.4702 17.64 5.2702 17.9C6.3502 18.26 7.4402 18.52 8.5502 18.71C8.6602 18.73 8.7702 18.74 8.8802 18.76C9.0202 18.7801 9.1702 18.8 9.3202 18.82C9.5802 18.8601 9.8402 18.89 10.1102 18.91C10.7402 18.97 11.3802 19 12.0202 19C12.6502 19 13.2802 18.97 13.9002 18.91C14.1302 18.89 14.3602 18.8701 14.5802 18.84C14.7602 18.82 14.9402 18.8001 15.1202 18.7701C15.2302 18.76 15.3402 18.74 15.4502 18.72C16.5702 18.54 17.6802 18.26 18.7602 17.9C19.5302 17.64 20.1202 17.06 20.4002 16.32C20.6802 15.57 20.6002 14.75 20.1902 14.06ZM12.7502 10C12.7502 10.42 12.4102 10.76 11.9902 10.76C11.5702 10.76 11.2302 10.42 11.2302 10V6.90005C11.2302 6.48005 11.5702 6.14005 11.9902 6.14005C12.4102 6.14005 12.7502 6.48005 12.7502 6.90005V10Z"
        fill="#899CA8"
      />
      <path
        d="M14.8302 20.01C14.4102 21.17 13.3002 22 12.0002 22C11.2102 22 10.4302 21.68 9.88018 21.11C9.56018 20.81 9.32018 20.41 9.18018 20C9.31018 20.02 9.44018 20.03 9.58018 20.05C9.81018 20.08 10.0502 20.11 10.2902 20.13C10.8602 20.18 11.4402 20.21 12.0202 20.21C12.5902 20.21 13.1602 20.18 13.7202 20.13C13.9302 20.11 14.1402 20.1 14.3402 20.07C14.5002 20.05 14.6602 20.03 14.8302 20.01Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Logout() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.8962 2C21.4065 2 21.8271 2.38604 21.8845 2.88338L21.8912 3V21C21.8912 21.5128 21.5071 21.9355 21.0122 21.9933L20.8962 22H14.9259C14.3763 22 13.9308 21.5523 13.9308 21C13.9308 20.4872 14.315 20.0645 14.8098 20.0067L14.9259 20H19.9011V4H14.9259C14.4156 4 13.995 3.61396 13.9375 3.11662L13.9308 3C13.9308 2.48716 14.315 2.06449 14.8098 2.00673L14.9259 2H20.8962ZM10.5605 6.2097L10.6542 6.29289L15.6295 11.2929C15.9882 11.6534 16.0158 12.2206 15.7123 12.6129L15.6295 12.7071L10.6542 17.7071C10.2656 18.0976 9.63562 18.0976 9.24702 17.7071C8.88832 17.3466 8.86073 16.7794 9.16425 16.3871L9.24702 16.2929L12.5228 13H2.98528C2.43573 13 1.99023 12.5523 1.99023 12C1.99023 11.4872 2.37436 11.0645 2.86924 11.0067L2.98528 11H12.5228L9.24702 7.70711C8.88832 7.34662 8.86073 6.77939 9.16425 6.3871L9.24702 6.29289C9.57583 5.96245 10.0775 5.91161 10.4595 6.14038L10.5605 6.2097Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function TotalPatients() {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_183_5678)">
        <rect
          x="0.424805"
          width="48"
          height="48"
          rx="24"
          fill="#00CFE8"
          fill-opacity="0.12"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24 16C21.9289 16 20.25 17.6789 20.25 19.75C20.25 21.8211 21.9289 23.5 24 23.5C26.0711 23.5 27.75 21.8211 27.75 19.75C27.75 17.6789 26.0711 16 24 16ZM21.75 19.75C21.75 18.5074 22.7574 17.5 24 17.5C25.2426 17.5 26.25 18.5074 26.25 19.75C26.25 20.9926 25.2426 22 24 22C22.7574 22 21.75 20.9926 21.75 19.75Z"
          fill="#00BCC1"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21 25C18.9289 25 17.25 26.6789 17.25 28.75C17.25 30.8211 18.9289 32.5 21 32.5H27C29.0711 32.5 30.75 30.8211 30.75 28.75C30.75 26.6789 29.0711 25 27 25H21ZM18.75 28.75C18.75 27.5074 19.7574 26.5 21 26.5H27C28.2426 26.5 29.25 27.5074 29.25 28.75C29.25 29.9926 28.2426 31 27 31H21C19.7574 31 18.75 29.9926 18.75 28.75Z"
          fill="#00BCC1"
        />
        <path
          d="M19.7521 22.3887C19.5944 22.1353 19.2985 22 19 22C17.7574 22 16.75 20.9926 16.75 19.75C16.75 18.5074 17.7574 17.5 19 17.5C19.2985 17.5 19.5944 17.3647 19.7521 17.1113C19.7591 17.1001 19.7661 17.089 19.7732 17.0778C20.0358 16.6633 19.9027 16.0764 19.415 16.0227C19.2787 16.0077 19.1403 16 19 16C16.9289 16 15.25 17.6789 15.25 19.75C15.25 21.8211 16.9289 23.5 19 23.5C19.1403 23.5 19.2787 23.4923 19.415 23.4773C19.9027 23.4236 20.0358 22.8367 19.7732 22.4222C19.7661 22.411 19.7591 22.3999 19.7521 22.3887Z"
          fill="#00BCC1"
        />
        <path
          d="M16.7083 30.3169C16.5948 30.1275 16.3944 30 16.1736 30H16C14.7574 30 13.75 28.9926 13.75 27.75C13.75 26.5074 14.7574 25.5 16 25.5H16.1736C16.3944 25.5 16.5948 25.3725 16.7083 25.1831C16.9854 24.7208 16.6847 24 16.1457 24H16C13.9289 24 12.25 25.6789 12.25 27.75C12.25 29.8211 13.9289 31.5 16 31.5H16.1457C16.6847 31.5 16.9854 30.7792 16.7083 30.3169Z"
          fill="#00BCC1"
        />
        <path
          d="M28.2268 22.4222C27.9642 22.8367 28.0973 23.4236 28.585 23.4773C28.7213 23.4923 28.8597 23.5 29 23.5C31.0711 23.5 32.75 21.8211 32.75 19.75C32.75 17.6789 31.0711 16 29 16C28.8597 16 28.7213 16.0077 28.585 16.0227C28.0973 16.0764 27.9642 16.6633 28.2268 17.0778C28.2339 17.089 28.2409 17.1001 28.2479 17.1113C28.4056 17.3647 28.7015 17.5 29 17.5C30.2426 17.5 31.25 18.5074 31.25 19.75C31.25 20.9926 30.2426 22 29 22C28.7015 22 28.4056 22.1353 28.2479 22.3887C28.2409 22.3999 28.2339 22.411 28.2268 22.4222Z"
          fill="#00BCC1"
        />
        <path
          d="M31.2917 30.3169C31.0146 30.7792 31.3153 31.5 31.8543 31.5H32C34.0711 31.5 35.75 29.8211 35.75 27.75C35.75 25.6789 34.0711 24 32 24H31.8543C31.3153 24 31.0146 24.7208 31.2917 25.1831C31.4052 25.3725 31.6056 25.5 31.8264 25.5H32C33.2426 25.5 34.25 26.5074 34.25 27.75C34.25 28.9926 33.2426 30 32 30H31.8264C31.6056 30 31.4052 30.1275 31.2917 30.3169Z"
          fill="#00BCC1"
        />
      </g>
      <defs>
        <clipPath id="clip0_183_5678">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.424805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TotalCare() {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_183_5666)">
        <rect
          x="0.30127"
          width="48"
          height="48"
          rx="24"
          fill="#EA5455"
          fill-opacity="0.12"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24 16C21.9289 16 20.25 17.6789 20.25 19.75C20.25 21.8211 21.9289 23.5 24 23.5C26.0711 23.5 27.75 21.8211 27.75 19.75C27.75 17.6789 26.0711 16 24 16ZM21.75 19.75C21.75 18.5074 22.7574 17.5 24 17.5C25.2426 17.5 26.25 18.5074 26.25 19.75C26.25 20.9926 25.2426 22 24 22C22.7574 22 21.75 20.9926 21.75 19.75Z"
          fill="#FF5A4E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21 25C18.9289 25 17.25 26.6789 17.25 28.75C17.25 30.8211 18.9289 32.5 21 32.5H27C29.0711 32.5 30.75 30.8211 30.75 28.75C30.75 26.6789 29.0711 25 27 25H21ZM18.75 28.75C18.75 27.5074 19.7574 26.5 21 26.5H27C28.2426 26.5 29.25 27.5074 29.25 28.75C29.25 29.9926 28.2426 31 27 31H21C19.7574 31 18.75 29.9926 18.75 28.75Z"
          fill="#FF5A4E"
        />
        <path
          d="M19.7521 22.3887C19.5944 22.1353 19.2985 22 19 22C17.7574 22 16.75 20.9926 16.75 19.75C16.75 18.5074 17.7574 17.5 19 17.5C19.2985 17.5 19.5944 17.3647 19.7521 17.1113C19.7591 17.1001 19.7661 17.089 19.7732 17.0778C20.0358 16.6633 19.9027 16.0764 19.415 16.0227C19.2787 16.0077 19.1403 16 19 16C16.9289 16 15.25 17.6789 15.25 19.75C15.25 21.8211 16.9289 23.5 19 23.5C19.1403 23.5 19.2787 23.4923 19.415 23.4773C19.9027 23.4236 20.0358 22.8367 19.7732 22.4222C19.7661 22.411 19.7591 22.3999 19.7521 22.3887Z"
          fill="#FF5A4E"
        />
        <path
          d="M16.7083 30.3169C16.5948 30.1275 16.3944 30 16.1736 30H16C14.7574 30 13.75 28.9926 13.75 27.75C13.75 26.5074 14.7574 25.5 16 25.5H16.1736C16.3944 25.5 16.5948 25.3725 16.7083 25.1831C16.9854 24.7208 16.6847 24 16.1457 24H16C13.9289 24 12.25 25.6789 12.25 27.75C12.25 29.8211 13.9289 31.5 16 31.5H16.1457C16.6847 31.5 16.9854 30.7792 16.7083 30.3169Z"
          fill="#FF5A4E"
        />
        <path
          d="M28.2268 22.4222C27.9642 22.8367 28.0973 23.4236 28.585 23.4773C28.7213 23.4923 28.8597 23.5 29 23.5C31.0711 23.5 32.75 21.8211 32.75 19.75C32.75 17.6789 31.0711 16 29 16C28.8597 16 28.7213 16.0077 28.585 16.0227C28.0973 16.0764 27.9642 16.6633 28.2268 17.0778C28.2339 17.089 28.2409 17.1001 28.2479 17.1113C28.4056 17.3647 28.7015 17.5 29 17.5C30.2426 17.5 31.25 18.5074 31.25 19.75C31.25 20.9926 30.2426 22 29 22C28.7015 22 28.4056 22.1353 28.2479 22.3887C28.2409 22.3999 28.2339 22.411 28.2268 22.4222Z"
          fill="#FF5A4E"
        />
        <path
          d="M31.2917 30.3169C31.0146 30.7792 31.3153 31.5 31.8543 31.5H32C34.0711 31.5 35.75 29.8211 35.75 27.75C35.75 25.6789 34.0711 24 32 24H31.8543C31.3153 24 31.0146 24.7208 31.2917 25.1831C31.4052 25.3725 31.6056 25.5 31.8264 25.5H32C33.2426 25.5 34.25 26.5074 34.25 27.75C34.25 28.9926 33.2426 30 32 30H31.8264C31.6056 30 31.4052 30.1275 31.2917 30.3169Z"
          fill="#FF5A4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_183_5666">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.30127)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TotalFinance() {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect
          x="0.287598"
          width="48"
          height="48"
          rx="24"
          fill="#7367F0"
          fill-opacity="0.12"
        />
        <path
          d="M36.2876 18V24C36.2876 24.6 35.8876 25 35.2876 25C34.6876 25 34.2876 24.6 34.2876 24V20.4L26.4876 28.2C26.0876 28.6 25.4876 28.6 25.0876 28.2L20.7876 23.9L13.9876 30.7C13.7876 30.9 13.5876 31 13.2876 31C12.9876 31 12.7876 30.9 12.5876 30.7C12.1876 30.3 12.1876 29.7 12.5876 29.3L20.0876 21.8C20.4876 21.4 21.0876 21.4 21.4876 21.8L25.7876 26.1L32.8876 19H29.2876C28.6876 19 28.2876 18.6 28.2876 18C28.2876 17.4 28.6876 17 29.2876 17H35.2876C35.3876 17 35.5876 17 35.6876 17.1C35.8876 17.2 36.0876 17.4 36.1876 17.6C36.2876 17.7 36.2876 17.9 36.2876 18Z"
          fill="black"
        />
        <mask
          id="mask0_183_5694"
          style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="12"
          y="17"
          width="25"
          height="14"
        >
          <path
            d="M36.2876 18V24C36.2876 24.6 35.8876 25 35.2876 25C34.6876 25 34.2876 24.6 34.2876 24V20.4L26.4876 28.2C26.0876 28.6 25.4876 28.6 25.0876 28.2L20.7876 23.9L13.9876 30.7C13.7876 30.9 13.5876 31 13.2876 31C12.9876 31 12.7876 30.9 12.5876 30.7C12.1876 30.3 12.1876 29.7 12.5876 29.3L20.0876 21.8C20.4876 21.4 21.0876 21.4 21.4876 21.8L25.7876 26.1L32.8876 19H29.2876C28.6876 19 28.2876 18.6 28.2876 18C28.2876 17.4 28.6876 17 29.2876 17H35.2876C35.3876 17 35.5876 17 35.6876 17.1C35.8876 17.2 36.0876 17.4 36.1876 17.6C36.2876 17.7 36.2876 17.9 36.2876 18Z"
            fill="white"
          />
        </mask>
      </g>
      <defs>
        <clipPath id="clip0_183_5694">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.287598)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TotalPlans() {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_183_5694)">
        <rect
          x="0.287598"
          width="48"
          height="48"
          rx="24"
          fill="#7367F0"
          fill-opacity="0.12"
        />
        <path
          d="M36.2876 18V24C36.2876 24.6 35.8876 25 35.2876 25C34.6876 25 34.2876 24.6 34.2876 24V20.4L26.4876 28.2C26.0876 28.6 25.4876 28.6 25.0876 28.2L20.7876 23.9L13.9876 30.7C13.7876 30.9 13.5876 31 13.2876 31C12.9876 31 12.7876 30.9 12.5876 30.7C12.1876 30.3 12.1876 29.7 12.5876 29.3L20.0876 21.8C20.4876 21.4 21.0876 21.4 21.4876 21.8L25.7876 26.1L32.8876 19H29.2876C28.6876 19 28.2876 18.6 28.2876 18C28.2876 17.4 28.6876 17 29.2876 17H35.2876C35.3876 17 35.5876 17 35.6876 17.1C35.8876 17.2 36.0876 17.4 36.1876 17.6C36.2876 17.7 36.2876 17.9 36.2876 18Z"
          fill="black"
        />
        <mask
          id="mask0_183_5694"
          style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="12"
          y="17"
          width="25"
          height="14"
        >
          <path
            d="M36.2876 18V24C36.2876 24.6 35.8876 25 35.2876 25C34.6876 25 34.2876 24.6 34.2876 24V20.4L26.4876 28.2C26.0876 28.6 25.4876 28.6 25.0876 28.2L20.7876 23.9L13.9876 30.7C13.7876 30.9 13.5876 31 13.2876 31C12.9876 31 12.7876 30.9 12.5876 30.7C12.1876 30.3 12.1876 29.7 12.5876 29.3L20.0876 21.8C20.4876 21.4 21.0876 21.4 21.4876 21.8L25.7876 26.1L32.8876 19H29.2876C28.6876 19 28.2876 18.6 28.2876 18C28.2876 17.4 28.6876 17 29.2876 17H35.2876C35.3876 17 35.5876 17 35.6876 17.1C35.8876 17.2 36.0876 17.4 36.1876 17.6C36.2876 17.7 36.2876 17.9 36.2876 18Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_183_5694)">
          <rect x="12.2876" y="12" width="24" height="24" fill="#7367F0" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_183_5694">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.287598)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TotalMonth() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_183_5650)">
        <rect
          width="48"
          height="48"
          rx="24"
          fill="#288EC7"
          fill-opacity="0.12"
        />
        <path
          d="M25.7299 15.51L27.4899 19.03C27.7299 19.52 28.3699 19.99 28.9099 20.08L32.0999 20.61C34.1399 20.95 34.6199 22.43 33.1499 23.89L30.6699 26.37C30.2499 26.79 30.0199 27.6 30.1499 28.18L30.8599 31.25C31.4199 33.68 30.1299 34.62 27.9799 33.35L24.9899 31.58C24.4499 31.26 23.5599 31.26 23.0099 31.58L20.0199 33.35C17.8799 34.62 16.5799 33.67 17.1399 31.25L17.8499 28.18C17.9799 27.6 17.7499 26.79 17.3299 26.37L14.8499 23.89C13.3899 22.43 13.8599 20.95 15.8999 20.61L19.0899 20.08C19.6199 19.99 20.2599 19.52 20.4999 19.03L22.2599 15.51C23.2199 13.6 24.7799 13.6 25.7299 15.51Z"
          stroke="#3B7AFE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_183_5650">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17C10.4845 17 12.3102 16.3199 13.7567 15.18L14.1601 15.5742L17.2929 18.7071L17.3871 18.7903C17.7794 19.0953 18.3466 19.0676 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L15.5661 14.1518L15.1721 13.7668C16.3167 12.3187 17 10.4892 17 8.5C17 3.80558 13.1944 0 8.5 0ZM8.5 2C12.0899 2 15 4.91015 15 8.5C15 12.0899 12.0899 15 8.5 15C4.91015 15 2 12.0899 2 8.5C2 4.91015 4.91015 2 8.5 2Z"
        fill="#0A1629"
      />
    </svg>
  );
}

export function DashboardNotification() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3399 14.49L18.3399 12.83C18.1299 12.46 17.9399 11.76 17.9399 11.35V8.82C17.9399 6.47 16.5599 4.44 14.5699 3.49C14.0499 2.57 13.0899 2 11.9899 2C10.8999 2 9.91994 2.59 9.39994 3.52C7.44994 4.49 6.09994 6.5 6.09994 8.82V11.35C6.09994 11.76 5.90994 12.46 5.69994 12.82L4.68994 14.49C4.28994 15.16 4.19994 15.9 4.44994 16.58C4.68994 17.25 5.25994 17.77 5.99994 18.02C7.93994 18.68 9.97994 19 12.0199 19C14.0599 19 16.0999 18.68 18.0399 18.03C18.7399 17.8 19.2799 17.27 19.5399 16.58C19.7999 15.89 19.7299 15.13 19.3399 14.49Z"
        fill="#363636"
      />
      <path
        d="M14.8299 20.01C14.4099 21.17 13.2999 22 11.9999 22C11.2099 22 10.4299 21.68 9.87993 21.11C9.55993 20.81 9.31993 20.41 9.17993 20C9.30993 20.02 9.43993 20.03 9.57993 20.05C9.80993 20.08 10.0499 20.11 10.2899 20.13C10.8599 20.18 11.4399 20.21 12.0199 20.21C12.5899 20.21 13.1599 20.18 13.7199 20.13C13.9299 20.11 14.1399 20.1 14.3399 20.07C14.4999 20.05 14.6599 20.03 14.8299 20.01Z"
        fill="#363636"
      />
    </svg>
  );
}

export function Profilearrow() {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.70711 0.292893C10.0676 0.653377 10.0953 1.22061 9.7903 1.6129L9.70711 1.70711L5.70711 5.70711C5.34662 6.06759 4.77939 6.09532 4.3871 5.7903L4.29289 5.70711L0.292893 1.70711C-0.0976305 1.31658 -0.0976305 0.683418 0.292893 0.292893C0.653378 -0.0675907 1.22061 -0.0953203 1.6129 0.209705L1.70711 0.292893L5 3.585L8.29289 0.292893C8.65338 -0.0675907 9.22061 -0.0953203 9.6129 0.209705L9.70711 0.292893Z"
        fill="#0A1629"
      />
    </svg>
  );
}

export function MainLogo() {
  return (
    <svg
      width="150"
      height="60"
      viewBox="0 0 150 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_33_151)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.7979 29.1291L40.1813 48.5126L57.5658 31.1281L28.7907 2.35297L22.7037 8.43991L45.3918 31.1281L39.8728 36.6473L26.5762 23.3506L20.7979 29.1291Z"
          fill="#3B7AFE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.015625 31.1281L17.2419 13.9019L23.3289 19.9888L12.1896 31.1281L34.8778 53.8163L28.7908 59.9032L0.015625 31.1281Z"
          fill="#3B7AFE"
        />
        <path
          d="M73.55 27.4598C75.8883 25.0932 78.7253 23.9099 82.0614 23.9099C85.4261 23.9099 88.2777 25.0932 90.6158 27.4598C92.9539 29.8266 94.123 32.678 94.123 36.0141C94.123 36.7271 94.066 37.5967 93.9519 38.6232H77.4422C77.7843 39.5641 78.4188 40.3268 79.3454 40.9115C80.2723 41.496 81.377 41.7883 82.6602 41.7883C84.7134 41.7883 86.3101 41.218 87.4507 40.0773L92.9682 43.5846C91.8561 44.9818 90.352 46.101 88.4557 46.9421C86.5596 47.7834 84.6278 48.204 82.6602 48.204C78.9819 48.204 75.9522 47.0276 73.5713 44.6754C71.1905 42.3229 70 39.4358 70 36.0141C70 32.678 71.1833 29.8266 73.55 27.4598ZM142.663 47.5364V24.3432H149.592V47.5364H142.663ZM118.906 15.354H138.494V22.454H126.263V28.6314H138.118V35.7314H126.263V47.5364H118.906V15.354ZM96.1516 30.5159V24.5359H113.877V29.596L104.906 41.2216H114.462V47.5364H95.912V42.8109L105.031 30.5159H96.1516ZM77.4849 33.4625H86.9374C86.7093 32.513 86.1603 31.7075 85.2907 31.0462C84.4211 30.385 83.3588 30.0543 82.1043 30.0543C80.8781 30.0543 79.8587 30.385 79.0461 31.0462C78.2335 31.7075 77.7131 32.513 77.4849 33.4625Z"
          fill="#3B7AFE"
        />
        <path
          d="M143.226 15.3511C142.419 16.1735 142.016 17.1481 142.016 18.2749C142.016 19.402 142.419 20.3691 143.226 21.1762C144.034 21.9833 145.001 22.3869 146.127 22.3869C147.254 22.3869 148.229 21.9758 149.052 21.1533C149.843 20.3615 150.239 19.402 150.239 18.2749C150.239 17.1481 149.836 16.1735 149.029 15.3511C148.221 14.5288 147.254 14.1177 146.128 14.1177C145.001 14.1177 144.034 14.5288 143.226 15.3511Z"
          fill="#5FBF24"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_151">
          <rect width="150" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Eye() {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_33_215)">
        <path
          d="M9.00003 7.63622C8.37423 7.63622 7.76249 7.82283 7.24216 8.17246C6.72182 8.52209 6.31628 9.01904 6.07679 9.60045C5.83731 10.1819 5.77465 10.8216 5.89674 11.4389C6.01882 12.0561 6.32018 12.6231 6.76268 13.0681C7.20519 13.513 7.76898 13.8161 8.38275 13.9389C8.99653 14.0616 9.63272 13.9986 10.2109 13.7578C10.789 13.517 11.2832 13.1091 11.6309 12.5859C11.9786 12.0626 12.1641 11.4474 12.1641 10.8181C12.1632 9.97451 11.8296 9.16572 11.2364 8.5692C10.6432 7.97268 9.83892 7.63715 9.00003 7.63622ZM9.00003 12.5856C8.65241 12.5856 8.31259 12.4819 8.02355 12.2877C7.73451 12.0935 7.50924 11.8175 7.37621 11.4945C7.24318 11.1715 7.20837 10.8162 7.27619 10.4733C7.34401 10.1304 7.51141 9.81549 7.75721 9.5683C8.00302 9.32111 8.31619 9.15277 8.65714 9.08458C8.99808 9.01638 9.35148 9.05138 9.67265 9.18516C9.99381 9.31893 10.2683 9.54547 10.4614 9.83614C10.6546 10.1268 10.7576 10.4685 10.7576 10.8181C10.757 11.2867 10.5717 11.7359 10.2422 12.0672C9.91269 12.3986 9.46599 12.585 9.00003 12.5856Z"
          fill="#899CA8"
        />
        <path
          d="M17.9243 9.14317C17.1201 7.56798 15.8873 6.25504 14.3696 5.35733L16.273 3.44322C16.3389 3.3777 16.3913 3.29974 16.4271 3.2138C16.4629 3.12787 16.4815 3.03566 16.4817 2.94249C16.482 2.84931 16.4639 2.757 16.4286 2.67086C16.3932 2.58473 16.3413 2.50647 16.2758 2.44058C16.2103 2.3747 16.1325 2.32248 16.0468 2.28695C15.9612 2.25141 15.8694 2.23325 15.7767 2.23351C15.6841 2.23377 15.5924 2.25245 15.5069 2.28847C15.4215 2.32448 15.3439 2.37713 15.2788 2.44339L13.0459 4.68883C11.9814 4.24745 10.8522 3.9847 9.70313 3.91106V0.707C9.70313 0.519492 9.62906 0.339663 9.49721 0.207075C9.36537 0.0744867 9.18655 0 9.00009 0C8.81363 0 8.6348 0.0744867 8.50296 0.207075C8.37111 0.339663 8.29704 0.519492 8.29704 0.707V3.91183C7.14798 3.98547 6.01873 4.24822 4.95428 4.68961L2.72178 2.44378C2.65663 2.37752 2.5791 2.32487 2.49364 2.28886C2.40819 2.25284 2.3165 2.23416 2.22384 2.2339C2.13119 2.23364 2.03939 2.2518 1.95374 2.28734C1.86809 2.32287 1.79026 2.37509 1.72475 2.44097C1.65923 2.50686 1.60731 2.58512 1.57197 2.67125C1.53663 2.75739 1.51857 2.8497 1.51883 2.94287C1.51909 3.03605 1.53766 3.12826 1.57348 3.21419C1.6093 3.30013 1.66165 3.3781 1.72754 3.44361L3.63094 5.35772C2.11373 6.25549 0.881375 7.56828 0.0774266 9.14317C0.00253317 9.30922 -0.00566888 9.49795 0.0545334 9.66994C0.114736 9.84193 0.238687 9.98388 0.400499 10.0661C0.562312 10.1484 0.749473 10.1646 0.922894 10.1114C1.09631 10.0582 1.24258 9.93966 1.33115 9.78056C2.63554 7.18278 5.5417 5.30289 9.00009 5.30289C12.4585 5.30289 15.3662 7.18511 16.6675 9.78056C16.7091 9.86344 16.7665 9.93727 16.8365 9.99783C16.9065 10.0584 16.9877 10.1045 17.0754 10.1335C17.1631 10.1625 17.2556 10.1739 17.3477 10.1669C17.4398 10.16 17.5296 10.1349 17.612 10.093C17.6944 10.0512 17.7679 9.99341 17.8281 9.92302C17.8883 9.85264 17.9342 9.77101 17.963 9.68281C17.9919 9.59461 18.0032 9.50155 17.9962 9.40896C17.9893 9.31637 17.9644 9.22605 17.9227 9.14317H17.9243Z"
          fill="#899CA8"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_215">
          <rect width="18" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function EyeClose() {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0618 7.82444L8.87356 9.05333C8.91227 9.04944 8.95097 9.04944 8.99355 9.04944C9.34148 9.04906 9.68171 9.15235 9.97121 9.34624C10.2607 9.54014 10.4865 9.81593 10.62 10.1388C10.7535 10.4616 10.7887 10.8169 10.7212 11.1599C10.6537 11.5028 10.4865 11.8179 10.2408 12.0654C9.99502 12.3128 9.68175 12.4815 9.34058 12.5501C8.99941 12.6187 8.64566 12.5841 8.32407 12.4506C8.00248 12.3172 7.72749 12.091 7.53387 11.8005C7.34025 11.5101 7.2367 11.1685 7.23632 10.8189C7.23568 10.7955 7.23697 10.7721 7.24019 10.7489L6.04419 11.9817C6.23738 12.4779 6.55144 12.9174 6.95758 13.26C7.36373 13.6027 7.84897 13.8374 8.36883 13.9427C8.88868 14.0479 9.42653 14.0204 9.93306 13.8627C10.4396 13.7049 10.8986 13.4219 11.268 13.0397C11.6375 12.6574 11.9055 12.1881 12.0476 11.6747C12.1896 11.1614 12.2011 10.6204 12.0811 10.1014C11.9611 9.58239 11.7133 9.10197 11.3605 8.70416C11.0077 8.30634 10.5612 8.00386 10.0618 7.82444Z"
        fill="#899CA8"
      />
      <path
        d="M10.7238 5.46778L11.8656 4.28556L11.8493 4.28128L15.0062 1.01461C15.1153 0.905231 15.1767 0.756778 15.1769 0.60191C15.177 0.447041 15.116 0.298443 15.0071 0.188806C14.8983 0.079168 14.7505 0.0174718 14.5964 0.0172895C14.4422 0.0171072 14.2943 0.0784536 14.1852 0.187833L10.5039 3.99894C10.2369 3.96006 9.96825 3.92933 9.69808 3.91222V0.707778C9.69808 0.520063 9.62387 0.340037 9.49176 0.207303C9.35965 0.0745692 9.18047 0 8.99364 0C8.80682 0 8.62764 0.0745692 8.49553 0.207303C8.36342 0.340037 8.2892 0.520063 8.2892 0.707778V3.91222C7.13951 3.98499 6.00963 4.24778 4.94505 4.69L2.71174 2.44222C2.57972 2.31163 2.40182 2.23851 2.21656 2.2387C2.03129 2.23888 1.85354 2.31235 1.72178 2.44321C1.59001 2.57406 1.51483 2.75178 1.51248 2.93791C1.51014 3.12404 1.58083 3.30362 1.70926 3.43778C1.71314 3.44167 1.71314 3.44167 1.71701 3.44167L3.62132 5.35889C2.10322 6.25667 0.869789 7.56877 0.0642805 9.14278C-0.011707 9.30886 -0.0206783 9.49807 0.0392509 9.67067C0.0991801 9.84326 0.223346 9.9858 0.385669 10.0684C0.547991 10.1509 0.735838 10.167 0.909753 10.1134C1.08367 10.0597 1.23012 9.94042 1.31834 9.78055C2.62272 7.18278 5.53337 5.30444 8.99364 5.30444C9.07454 5.30444 9.15195 5.31339 9.23207 5.31533L1.82229 12.9889C1.71332 13.0982 1.65204 13.2466 1.65193 13.4013C1.65182 13.556 1.71289 13.7044 1.8217 13.8139C1.93052 13.9234 2.07816 13.985 2.23215 13.9851C2.38615 13.9852 2.53388 13.9238 2.64284 13.8145L10.7056 5.46506L10.7238 5.46778Z"
        fill="#899CA8"
      />
      <path
        d="M17.9269 9.14278C17.1225 7.56798 15.8888 6.25561 14.3698 5.35889L16.2741 3.44167C16.4066 3.30965 16.4814 3.13018 16.4821 2.94275C16.4828 2.75532 16.4094 2.57527 16.278 2.44222C16.1466 2.30917 15.968 2.23401 15.7814 2.23329C15.5949 2.23256 15.4157 2.30631 15.2833 2.43833L14.6524 3.07222L12.0088 5.81C14.0157 6.4766 15.6865 7.90017 16.6689 9.78056C16.7531 9.94816 16.9001 10.0753 17.0776 10.134C17.2551 10.1927 17.4485 10.1782 17.6153 10.0936C17.7821 10.009 17.9086 9.86135 17.9671 9.68303C18.0255 9.50471 18.011 9.31038 17.9269 9.14278Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Tick() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8966 4C14.2069 2.75862 13.2414 1.7931 12 1.10345C10.7586 0.413793 9.51724 0 8 0C6.62069 0 5.24138 0.413793 4 1.10345C2.75862 1.7931 1.7931 2.75862 1.10345 4C0.413793 5.24138 0 6.62069 0 8C0 9.37931 0.413793 10.7586 1.10345 12C1.7931 13.2414 2.75862 14.2069 4 14.8966C5.24138 15.5862 6.62069 16 8 16C9.37931 16 10.7586 15.5862 12 14.8966C13.2414 14.2069 14.2069 13.2414 14.8966 12C15.5862 10.7586 16 9.37931 16 8C16 6.62069 15.7241 5.24138 14.8966 4ZM13.1034 6.34483L7.03448 12.2759C7.03448 12.4138 6.89655 12.4138 6.75862 12.4138C6.62069 12.4138 6.48276 12.4138 6.34483 12.2759L3.03448 8.82759C2.89655 8.82759 2.89655 8.68965 2.89655 8.55172C2.89655 8.41379 2.89655 8.27586 3.03448 8.13793L3.72414 7.44828C3.86207 7.31034 4 7.31034 4.13793 7.31034C4.27586 7.31034 4.41379 7.31034 4.55172 7.44828L6.75862 9.65517L11.5862 4.82759C11.7241 4.68965 11.8621 4.68965 12 4.68965C12.1379 4.68965 12.2759 4.68965 12.4138 4.82759L13.1034 5.51724C13.2414 5.65517 13.2414 5.65517 13.2414 5.7931C13.2414 6.06896 13.1034 6.2069 13.1034 6.34483Z"
        fill="#5FBF24"
      />
    </svg>
  );
}

export function DateRangeCalender() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.75 3.56V2C16.75 1.59 16.41 1.25 16 1.25C15.59 1.25 15.25 1.59 15.25 2V3.5H8.74999V2C8.74999 1.59 8.40999 1.25 7.99999 1.25C7.58999 1.25 7.24999 1.59 7.24999 2V3.56C4.54999 3.81 3.23999 5.42 3.03999 7.81C3.01999 8.1 3.25999 8.34 3.53999 8.34H20.46C20.75 8.34 20.99 8.09 20.96 7.81C20.76 5.42 19.45 3.81 16.75 3.56Z"
        fill="#5FBF24"
      />
      <path
        d="M20 9.83997H4C3.45 9.83997 3 10.29 3 10.84V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V10.84C21 10.29 20.55 9.83997 20 9.83997ZM9.21 18.21C9.16 18.25 9.11 18.3 9.06 18.33C9 18.37 8.94 18.4 8.88 18.42C8.82 18.45 8.76 18.47 8.7 18.48C8.63 18.49 8.57 18.5 8.5 18.5C8.37 18.5 8.24 18.47 8.12 18.42C7.99 18.37 7.89 18.3 7.79 18.21C7.61 18.02 7.5 17.76 7.5 17.5C7.5 17.24 7.61 16.98 7.79 16.79C7.89 16.7 7.99 16.63 8.12 16.58C8.3 16.5 8.5 16.48 8.7 16.52C8.76 16.53 8.82 16.55 8.88 16.58C8.94 16.6 9 16.63 9.06 16.67C9.11 16.71 9.16 16.75 9.21 16.79C9.39 16.98 9.5 17.24 9.5 17.5C9.5 17.76 9.39 18.02 9.21 18.21ZM9.21 14.71C9.02 14.89 8.76 15 8.5 15C8.24 15 7.98 14.89 7.79 14.71C7.61 14.52 7.5 14.26 7.5 14C7.5 13.74 7.61 13.48 7.79 13.29C8.07 13.01 8.51 12.92 8.88 13.08C9.01 13.13 9.12 13.2 9.21 13.29C9.39 13.48 9.5 13.74 9.5 14C9.5 14.26 9.39 14.52 9.21 14.71ZM12.71 18.21C12.52 18.39 12.26 18.5 12 18.5C11.74 18.5 11.48 18.39 11.29 18.21C11.11 18.02 11 17.76 11 17.5C11 17.24 11.11 16.98 11.29 16.79C11.66 16.42 12.34 16.42 12.71 16.79C12.89 16.98 13 17.24 13 17.5C13 17.76 12.89 18.02 12.71 18.21ZM12.71 14.71C12.66 14.75 12.61 14.79 12.56 14.83C12.5 14.87 12.44 14.9 12.38 14.92C12.32 14.95 12.26 14.97 12.2 14.98C12.13 14.99 12.07 15 12 15C11.74 15 11.48 14.89 11.29 14.71C11.11 14.52 11 14.26 11 14C11 13.74 11.11 13.48 11.29 13.29C11.38 13.2 11.49 13.13 11.62 13.08C11.99 12.92 12.43 13.01 12.71 13.29C12.89 13.48 13 13.74 13 14C13 14.26 12.89 14.52 12.71 14.71ZM16.21 18.21C16.02 18.39 15.76 18.5 15.5 18.5C15.24 18.5 14.98 18.39 14.79 18.21C14.61 18.02 14.5 17.76 14.5 17.5C14.5 17.24 14.61 16.98 14.79 16.79C15.16 16.42 15.84 16.42 16.21 16.79C16.39 16.98 16.5 17.24 16.5 17.5C16.5 17.76 16.39 18.02 16.21 18.21ZM16.21 14.71C16.16 14.75 16.11 14.79 16.06 14.83C16 14.87 15.94 14.9 15.88 14.92C15.82 14.95 15.76 14.97 15.7 14.98C15.63 14.99 15.56 15 15.5 15C15.24 15 14.98 14.89 14.79 14.71C14.61 14.52 14.5 14.26 14.5 14C14.5 13.74 14.61 13.48 14.79 13.29C14.89 13.2 14.99 13.13 15.12 13.08C15.3 13 15.5 12.98 15.7 13.02C15.76 13.03 15.82 13.05 15.88 13.08C15.94 13.1 16 13.13 16.06 13.17C16.11 13.21 16.16 13.25 16.21 13.29C16.39 13.48 16.5 13.74 16.5 14C16.5 14.26 16.39 14.52 16.21 14.71Z"
        fill="#5FBF24"
      />
    </svg>
  );
}

export function ProfileIcon() {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C5.37665 0 3.25 2.12665 3.25 4.75C3.25 7.37335 5.37665 9.5 8 9.5C10.6234 9.5 12.75 7.37335 12.75 4.75C12.75 2.12665 10.6234 0 8 0Z"
        fill="#989898"
      />
      <path
        d="M5 11C2.37665 11 0.25 13.1266 0.25 15.75C0.25 18.3734 2.37665 20.5 5 20.5H11C13.6234 20.5 15.75 18.3734 15.75 15.75C15.75 13.1266 13.6234 11 11 11H5Z"
        fill="#989898"
      />
    </svg>
  );
}

export function LockIcon() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9956 5.23375C15.8736 2.29884 13.2127 0 10 0C6.71081 0 4 2.40961 4 5.44444V8C1.79086 8 0 9.79086 0 12V17C0 19.2091 1.79086 21 4 21H16C18.2091 21 20 19.2091 20 17V12C20 9.79086 18.2091 8 16 8V5.44444L15.9956 5.23375ZM14 8V5.44444C14 3.57008 12.2337 2 10 2C7.8384 2 6.11444 3.47042 6.00547 5.26405L6 5.44444V8H14Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function DeleteIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.07 5.23C19.46 5.07 17.85 4.95 16.23 4.86V4.85L16.01 3.55C15.86 2.63 15.64 1.25 13.3 1.25H10.68C8.35004 1.25 8.13003 2.57 7.97004 3.54L7.76004 4.82C6.83004 4.88 5.90004 4.94 4.97004 5.03L2.93004 5.23C2.51004 5.27 2.21004 5.64 2.25004 6.05C2.29004 6.46 2.65004 6.76 3.07004 6.72L5.11004 6.52C10.35 6 15.63 6.2 20.93 6.73C20.96 6.73 20.98 6.73 21.01 6.73C21.39 6.73 21.72 6.44 21.76 6.05C21.79 5.64 21.49 5.27 21.07 5.23Z"
        fill="#899CA8"
      />
      <path
        d="M19.23 8.14C18.99 7.89 18.66 7.75 18.32 7.75H5.67999C5.33999 7.75 4.99999 7.89 4.76999 8.14C4.53999 8.39 4.40999 8.73 4.42999 9.08L5.04999 19.34C5.15999 20.86 5.29999 22.76 8.78999 22.76H15.21C18.7 22.76 18.84 20.87 18.95 19.34L19.57 9.09C19.59 8.73 19.46 8.39 19.23 8.14ZM13.66 17.75H10.33C9.91999 17.75 9.57999 17.41 9.57999 17C9.57999 16.59 9.91999 16.25 10.33 16.25H13.66C14.07 16.25 14.41 16.59 14.41 17C14.41 17.41 14.07 17.75 13.66 17.75ZM14.5 13.75H9.49999C9.08999 13.75 8.74999 13.41 8.74999 13C8.74999 12.59 9.08999 12.25 9.49999 12.25H14.5C14.91 12.25 15.25 12.59 15.25 13C15.25 13.41 14.91 13.75 14.5 13.75Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="45"
        height="45"
        rx="12.5"
        fill="white"
        stroke="#F5F1FE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.8787 12.8787L19.2929 21.4645C19.1054 21.652 19 21.9064 19 22.1716V26.1716C19 26.7239 19.4477 27.1716 20 27.1716H24C24.2652 27.1716 24.5196 27.0662 24.7071 26.8787L33.2929 18.2929C34.4645 17.1213 34.4645 15.2218 33.2929 14.0503L32.1213 12.8787C30.9497 11.7071 29.0503 11.7071 27.8787 12.8787ZM31.8787 15.4645L31.9619 15.5587C32.2669 15.951 32.2392 16.5182 31.8787 16.8787L23.584 25.1716H21V22.5856L29.2929 14.2929C29.6834 13.9024 30.3166 13.9024 30.7071 14.2929L31.8787 15.4645ZM23.0308 14.1716C23.0308 13.6193 22.5831 13.1716 22.0308 13.1716H18L17.7831 13.1762C15.1223 13.2898 13 15.4828 13 18.1716V28.1716L13.0046 28.3885C13.1182 31.0493 15.3112 33.1716 18 33.1716H28L28.2169 33.167C30.8777 33.0534 33 30.8603 33 28.1716V23.2533L32.9933 23.1366C32.9355 22.6393 32.5128 22.2533 32 22.2533C31.4477 22.2533 31 22.701 31 23.2533V28.1716L30.9949 28.3478C30.9037 29.9227 29.5977 31.1716 28 31.1716H18L17.8237 31.1665C16.2489 31.0752 15 29.7693 15 28.1716V18.1716L15.0051 17.9953C15.0963 16.4205 16.4023 15.1716 18 15.1716H22.0308L22.1474 15.1648C22.6448 15.1071 23.0308 14.6844 23.0308 14.1716Z"
        fill="#363636"
      />
    </svg>
  );
}

export function MenuDots() {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.55556" cy="6.99989" r="1.55556" fill="#899CA8" />
      <circle cx="1.55556" cy="1.55556" r="1.55556" fill="#899CA8" />
      <circle cx="1.55556" cy="12.4442" r="1.55556" fill="#899CA8" />
    </svg>
  );
}

export function EyeHide() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2699 9.18005C20.9799 8.72005 20.6699 8.29005 20.3499 7.89005C19.9799 7.42005 19.2799 7.38005 18.8599 7.80005L15.8599 10.8001C16.0799 11.4601 16.1199 12.2201 15.9199 13.0101C15.5699 14.4201 14.4299 15.5601 13.0199 15.9101C12.2299 16.1101 11.4699 16.0701 10.8099 15.8501C10.8099 15.8501 9.37995 17.2801 8.34995 18.3101C7.84995 18.8101 8.00995 19.6901 8.67995 19.9501C9.74995 20.3601 10.8599 20.5701 11.9999 20.5701C13.7799 20.5701 15.5099 20.0501 17.0899 19.0801C18.6999 18.0801 20.1499 16.6101 21.3199 14.74C22.2699 13.2301 22.2199 10.6901 21.2699 9.18005Z"
        fill="#899CA8"
      />
      <path
        d="M14.0199 9.97989L9.97989 14.0199C9.46989 13.4999 9.13989 12.7799 9.13989 11.9999C9.13989 10.4299 10.4199 9.13989 11.9999 9.13989C12.7799 9.13989 13.4999 9.46989 14.0199 9.97989Z"
        fill="#899CA8"
      />
      <path
        d="M18.25 5.74993L14.86 9.13993C14.13 8.39993 13.12 7.95993 12 7.95993C9.76 7.95993 7.96 9.76993 7.96 11.9999C7.96 13.1199 8.41 14.1299 9.14 14.8599L5.76 18.2499H5.75C4.64 17.3499 3.62 16.1999 2.75 14.8399C1.75 13.2699 1.75 10.7199 2.75 9.14993C3.91 7.32993 5.33 5.89993 6.91 4.91993C8.49 3.95993 10.22 3.42993 12 3.42993C14.23 3.42993 16.39 4.24993 18.25 5.74993Z"
        fill="#899CA8"
      />
      <path
        d="M14.8601 12.0001C14.8601 13.5701 13.5801 14.8601 12.0001 14.8601C11.9401 14.8601 11.8901 14.8601 11.8301 14.8401L14.8401 11.8301C14.8601 11.8901 14.8601 11.9401 14.8601 12.0001Z"
        fill="#899CA8"
      />
      <path
        d="M21.7699 2.22988C21.4699 1.92988 20.9799 1.92988 20.6799 2.22988L2.22988 20.6899C1.92988 20.9899 1.92988 21.4799 2.22988 21.7799C2.37988 21.9199 2.56988 21.9999 2.76988 21.9999C2.96988 21.9999 3.15988 21.9199 3.30988 21.7699L21.7699 3.30988C22.0799 3.00988 22.0799 2.52988 21.7699 2.22988Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function ThreeDots() {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.55556" cy="6.99989" r="1.55556" fill="#899CA8" />
      <circle cx="1.55556" cy="1.55556" r="1.55556" fill="#899CA8" />
      <circle cx="1.55556" cy="12.4442" r="1.55556" fill="#899CA8" />
    </svg>
  );
}

export function GreenTick() {
  return (
    <svg
      width="15"
      height="11"
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.36893 11C5.06878 11 4.78364 10.8772 4.57354 10.6624L0.326413 6.31915C-0.108804 5.87408 -0.108804 5.13743 0.326413 4.69236C0.761631 4.2473 1.48199 4.2473 1.91721 4.69236L5.36893 8.22218L13.0828 0.333798C13.518 -0.111266 14.2384 -0.111266 14.6736 0.333798C15.1088 0.778863 15.1088 1.51552 14.6736 1.96059L6.16433 10.6624C5.95423 10.8772 5.66908 11 5.36893 11Z"
        fill="#5FBF24"
      />
    </svg>
  );
}

export function Telephone() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.11183 0.97505C5.05974 0.00831676 3.44259 0.00831676 2.3905 0.97505C2.34741 1.01464 2.30142 1.06065 2.24169 1.12039L1.34419 2.01788C0.441081 2.921 0.0619618 4.22292 0.339024 5.4697C1.91099 12.5436 7.43553 18.0681 14.5094 19.6401C15.7562 19.9171 17.0581 19.538 17.9612 18.6349L18.8586 17.7375C18.9184 17.6777 18.9644 17.6317 19.004 17.5886C19.9708 16.5365 19.9708 14.9193 19.004 13.8673C18.9644 13.8241 18.9184 13.7781 18.8586 13.7184L17.3894 12.2491C16.3693 11.229 14.8287 10.9372 13.5063 11.5137C12.7492 11.8437 11.8672 11.6767 11.2832 11.0927L8.88639 8.69589C8.30239 8.11188 8.13536 7.22994 8.46538 6.47283C9.04184 5.15037 8.75009 3.60984 7.72999 2.58974L6.26066 1.12041C6.20093 1.06066 6.15492 1.01464 6.11183 0.97505Z"
        fill="#3B7AFE"
      />
    </svg>
  );
}

export function Envelope() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.333223 3.40947C0 4.64946 0 6.36008 0 9C0 12.7497 0 14.6246 0.954915 15.9389C1.26331 16.3634 1.6366 16.7367 2.06107 17.0451C3.3754 18 5.25027 18 9 18H11C14.7497 18 16.6246 18 17.9389 17.0451C18.3634 16.7367 18.7367 16.3634 19.0451 15.9389C20 14.6246 20 12.7497 20 9C20 6.35129 20 4.63806 19.6634 3.39709L17.5607 5.49986C15.9284 7.13214 14.6492 8.41132 13.517 9.2752C12.3581 10.1594 11.2653 10.6789 9.99986 10.6789C8.73441 10.6789 7.64167 10.1594 6.48274 9.2752C5.35048 8.41132 4.07131 7.13213 2.43904 5.49984L0.483855 3.54466L0.333223 3.40947Z"
        fill="#3B7AFE"
      />
      <path
        d="M1 2L1.10885 2.09007L1.51587 2.45535L3.45913 4.39861C5.14079 6.08027 6.34981 7.28703 7.39261 8.08267C8.41812 8.8651 9.19425 9.17894 9.99986 9.17894C10.8055 9.17894 11.5816 8.8651 12.6071 8.08267C13.6499 7.28703 14.8589 6.08027 16.5406 4.39861L18.8485 2.0907L18.9741 1.96579C18.6657 1.54132 18.3634 1.26331 17.9389 0.954915C16.6246 0 14.7497 0 11 0H9C5.25027 0 3.3754 0 2.06107 0.954915C1.6366 1.26331 1.3084 1.57553 1 2Z"
        fill="#3B7AFE"
      />
    </svg>
  );
}

export function Loc() {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.7808 18.7005C13.0905 15.7551 16 11.4759 16 8.6087C16 3.85424 12.4183 0 8 0C3.58172 0 0 3.85424 0 8.6087C0 11.4759 2.90945 15.7551 5.21921 18.7005C6.42425 20.2371 7.02677 21.0055 8 21.0055C8.97323 21.0055 9.57575 20.2371 10.7808 18.7005ZM8 12C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6C9.65685 6 11 7.34315 11 9C11 10.6569 9.65685 12 8 12Z"
        fill="#3B7AFE"
      />
    </svg>
  );
}

export function PrivacyIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 1H5C2.79086 1 1 2.79086 1 5V10C1 14.3666 3.65957 18.1686 8.83853 21.3794C10.7752 22.58 13.2248 22.58 15.1615 21.3794L15.5314 21.1463C20.4685 17.983 23 14.2589 23 10V5C23 2.79086 21.2091 1 19 1Z"
        fill="#899CA8"
      />
      <path
        d="M16.2994 6.29075C16.69 5.90033 17.3232 5.9005 17.7136 6.29113C18.074 6.65171 18.1015 7.21895 17.7964 7.61116L17.7132 7.70534L11.7072 13.7081C11.3465 14.0687 10.779 14.0961 10.3868 13.7906L10.2926 13.7073L7.29621 10.706C6.90601 10.3151 6.90654 9.68193 7.29739 9.29174C7.65818 8.93156 8.22543 8.9043 8.61747 9.20965L8.7116 9.29292L11.0003 11.5858L16.2994 6.29075Z"
        fill="white"
      />
    </svg>
  );
}

export function FaqIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16998 22.1094C7.42998 22.2494 7.72 22.3194 8 22.3194C8.34 22.3194 8.67997 22.2195 8.96997 22.0295L13.23 19.1894H17C20.44 19.1894 22.75 16.8794 22.75 13.4394V7.43945C22.75 3.99945 20.44 1.68945 17 1.68945H7C3.56 1.68945 1.25 3.99945 1.25 7.43945V13.4394C1.25 16.6194 3.23 18.8395 6.25 19.1495V20.5694C6.25 21.2094 6.59998 21.8094 7.16998 22.1094Z"
        fill="#899CA8"
      />
      <path
        d="M11.9998 12.1094C11.5898 12.1094 11.2498 11.7694 11.2498 11.3594V11.1494C11.2498 9.98941 12.0998 9.4194 12.4198 9.1994C12.7898 8.9494 12.9098 8.77941 12.9098 8.51941C12.9098 8.01941 12.4998 7.60938 11.9998 7.60938C11.4998 7.60938 11.0898 8.01941 11.0898 8.51941C11.0898 8.92941 10.7498 9.26941 10.3398 9.26941C9.92984 9.26941 9.58984 8.92941 9.58984 8.51941C9.58984 7.18941 10.6698 6.10938 11.9998 6.10938C13.3298 6.10938 14.4098 7.18941 14.4098 8.51941C14.4098 9.65941 13.5698 10.2294 13.2598 10.4394C12.8698 10.6994 12.7498 10.8694 12.7498 11.1494V11.3594C12.7498 11.7794 12.4098 12.1094 11.9998 12.1094Z"
        fill="white"
      />
      <path
        d="M12 14.5996C11.58 14.5996 11.25 14.2596 11.25 13.8496C11.25 13.4396 11.59 13.0996 12 13.0996C12.41 13.0996 12.75 13.4396 12.75 13.8496C12.75 14.2596 12.42 14.5996 12 14.5996Z"
        fill="white"
      />
    </svg>
  );
}

export function TermsIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 4.91094C16 6.12338 14.99 7.11094 13.75 7.11094H10.25C9.63 7.11094 9.07 6.86649 8.66 6.4656C8.25 6.06472 8 5.51716 8 4.91094C8 3.69849 9.01 2.71094 10.25 2.71094H13.75C14.37 2.71094 14.93 2.95538 15.34 3.35627C15.75 3.75716 16 4.30472 16 4.91094Z"
        fill="#899CA8"
      />
      <path
        d="M18.83 5.67437C18.6 5.48859 18.34 5.34193 18.06 5.23437C17.77 5.12682 17.48 5.3517 17.42 5.64504C17.08 7.31704 15.57 8.57837 13.75 8.57837H10.25C9.25 8.57837 8.31 8.19704 7.6 7.50282C7.08 6.99437 6.72 6.34904 6.58 5.65482C6.52 5.36148 6.22 5.12682 5.93 5.24415C4.77 5.7037 4 6.74015 4 8.82282V18.3561C4 21.2895 5.79 22.2673 8 22.2673H16C18.21 22.2673 20 21.2895 20 18.3561V8.82282C20 7.22904 19.55 6.25126 18.83 5.67437ZM8 12.7339H12C12.41 12.7339 12.75 13.0664 12.75 13.4673C12.75 13.8681 12.41 14.2006 12 14.2006H8C7.59 14.2006 7.25 13.8681 7.25 13.4673C7.25 13.0664 7.59 12.7339 8 12.7339ZM16 18.1117H8C7.59 18.1117 7.25 17.7793 7.25 17.3784C7.25 16.9775 7.59 16.645 8 16.645H16C16.41 16.645 16.75 16.9775 16.75 17.3784C16.75 17.7793 16.41 18.1117 16 18.1117Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function AppointmentArrow() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="24"
        height="23.7126"
        rx="5"
        fill="#F9FAFA"
        stroke="#C4CBD6"
        stroke-opacity="0.103611"
      />
      <path
        d="M16.8178 14.3168L14.9829 12.4819L13.8625 11.3558C13.3881 10.8814 12.6164 10.8814 12.142 11.3558L9.181 14.3168C8.79231 14.7055 9.0724 15.3686 9.61543 15.3686H12.8222H16.3834C16.9321 15.3686 17.2065 14.7055 16.8178 14.3168Z"
        fill="#899CA8"
      />
    </svg>
  );
}


export function PaymentTick(){
  return(
    <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.36893 11C5.06878 11 4.78364 10.8772 4.57354 10.6624L0.326413 6.31915C-0.108804 5.87408 -0.108804 5.13743 0.326413 4.69236C0.761631 4.2473 1.48199 4.2473 1.91721 4.69236L5.36893 8.22218L13.0828 0.333798C13.518 -0.111266 14.2384 -0.111266 14.6736 0.333798C15.1088 0.778863 15.1088 1.51552 14.6736 1.96059L6.16433 10.6624C5.95423 10.8772 5.66908 11 5.36893 11Z" fill="#5FBF24"/>
</svg>
  )
}


export function FileUpload(){
  return(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.21783 20.9384L7.1005 21.6792H7.1005L7.21783 20.9384ZM3.06156 16.7822L3.80232 16.6648L3.06156 16.7822ZM20.9384 16.7822L21.6792 16.8995V16.8995L20.9384 16.7822ZM16.7822 20.9384L16.8995 21.6792H16.8995L16.7822 20.9384ZM20.6 10.5496C20.3513 10.2184 19.8811 10.1516 19.5499 10.4003C19.2187 10.6491 19.1519 11.1192 19.4007 11.4504L20.6 10.5496ZM4.59931 11.4504C4.84808 11.1192 4.78126 10.6491 4.45007 10.4003C4.11888 10.1516 3.64873 10.2184 3.39996 10.5496L4.59931 11.4504ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM7.41232 6.53403C7.15497 6.8586 7.20946 7.33034 7.53403 7.58768C7.8586 7.84503 8.33034 7.79054 8.58768 7.46597L7.41232 6.53403ZM9.39785 5.23703L8.81016 4.77106L9.39785 5.23703ZM14.6022 5.23703L15.1898 4.77106L14.6022 5.23703ZM15.4123 7.46597C15.6697 7.79054 16.1414 7.84503 16.466 7.58768C16.7905 7.33034 16.845 6.8586 16.5877 6.53403L15.4123 7.46597ZM11.7493 3.01989L11.6313 2.27923L11.6313 2.27923L11.7493 3.01989ZM12.2507 3.01989L12.3687 2.27923L12.3687 2.27923L12.2507 3.01989ZM20.25 14V15H21.75V14H20.25ZM15 20.25H9V21.75H15V20.25ZM3.75 15V14H2.25V15H3.75ZM9 20.25C8.04233 20.25 7.65082 20.2477 7.33515 20.1977L7.1005 21.6792C7.56216 21.7523 8.09965 21.75 9 21.75V20.25ZM2.25 15C2.25 15.9003 2.24767 16.4378 2.32079 16.8995L3.80232 16.6648C3.75233 16.3492 3.75 15.9577 3.75 15H2.25ZM7.33515 20.1977C5.51661 19.9096 4.09035 18.4834 3.80232 16.6648L2.32079 16.8995C2.71048 19.3599 4.64012 21.2895 7.1005 21.6792L7.33515 20.1977ZM20.25 15C20.25 15.9577 20.2477 16.3492 20.1977 16.6648L21.6792 16.8995C21.7523 16.4378 21.75 15.9003 21.75 15H20.25ZM15 21.75C15.9003 21.75 16.4378 21.7523 16.8995 21.6792L16.6648 20.1977C16.3492 20.2477 15.9577 20.25 15 20.25V21.75ZM20.1977 16.6648C19.9096 18.4834 18.4834 19.9096 16.6648 20.1977L16.8995 21.6792C19.3599 21.2895 21.2895 19.3599 21.6792 16.8995L20.1977 16.6648ZM21.75 14C21.75 12.7064 21.3219 11.5106 20.6 10.5496L19.4007 11.4504C19.9342 12.1607 20.25 13.0424 20.25 14H21.75ZM3.75 14C3.75 13.0424 4.06583 12.1607 4.59931 11.4504L3.39996 10.5496C2.67806 11.5106 2.25 12.7064 2.25 14H3.75ZM12.75 17V4H11.25V17H12.75ZM8.58768 7.46597L9.98553 5.703L8.81016 4.77106L7.41232 6.53403L8.58768 7.46597ZM14.0145 5.703L15.4123 7.46597L16.5877 6.53403L15.1898 4.77106L14.0145 5.703ZM9.98553 5.703C10.5543 4.98568 10.9418 4.49884 11.2682 4.17113C11.5913 3.84678 11.7612 3.77747 11.8673 3.76055L11.6313 2.27923C11.0582 2.37055 10.6096 2.70685 10.2055 3.11252C9.80475 3.51484 9.35616 4.08245 8.81016 4.77106L9.98553 5.703ZM15.1898 4.77106C14.6438 4.08245 14.1953 3.51484 13.7945 3.11252C13.3904 2.70685 12.9418 2.37055 12.3687 2.27923L12.1327 3.76055C12.2388 3.77747 12.4087 3.84678 12.7318 4.17113C13.0582 4.49884 13.4457 4.98568 14.0145 5.703L15.1898 4.77106ZM11.8673 3.76055C11.9117 3.75348 11.9559 3.75 12 3.75V2.25C11.8766 2.25 11.7534 2.25978 11.6313 2.27923L11.8673 3.76055ZM12 3.75C12.0441 3.75 12.0883 3.75348 12.1327 3.76055L12.3687 2.27923C12.2466 2.25978 12.1234 2.25 12 2.25V3.75ZM12.75 4V3H11.25V4H12.75Z" fill="#3B7AFE"/>
</svg>

  )
}

export function FilterIcon(){
  return(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 2C4.44772 2 4 2.44772 4 3V5.00001H20V3C20 2.44772 19.5523 2 19 2H5ZM19.7822 7.00001H4.21776C4.3321 7.22455 4.48907 7.42794 4.68299 7.59762L10.683 12.8476C11.437 13.5074 12.563 13.5074 13.317 12.8476L19.317 7.59762C19.5109 7.42794 19.6679 7.22455 19.7822 7.00001Z" fill="#899CA8"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14 16.7049L14 10H10V18.7049L14 16.7049Z" fill="#899CA8"/>
</svg>
  )
}

export function UserIcon(){
  return(
    <svg width="4" height="14" viewBox="0 0 4 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="1.55556" cy="6.99989" r="1.55556" fill="#899CA8"/>
<circle cx="1.55556" cy="1.55556" r="1.55556" fill="#899CA8"/>
<circle cx="1.55556" cy="12.4442" r="1.55556" fill="#899CA8"/>
</svg>

  )
}

export function InputDropdown(){
  return(
    <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3615 0.292861C10.5453 0.465054 10.6557 0.694154 10.672 0.93718C10.6883 1.18021 10.6094 1.42046 10.4501 1.61286L10.3615 1.70686L6.09121 5.70686C5.90739 5.87904 5.66281 5.98247 5.40336 5.99775C5.14391 6.01303 4.88743 5.93911 4.68203 5.78986L4.58167 5.70686L0.311404 1.70686C0.119938 1.5269 0.00877641 1.28543 0.000497855 1.03148C-0.0077807 0.777528 0.0874441 0.530148 0.266831 0.339583C0.446219 0.149017 0.696317 0.0295559 0.966329 0.00546227C1.23634 -0.0186313 1.50602 0.0544494 1.72059 0.209861L1.82094 0.292861L5.33644 3.58486L8.85194 0.292861C9.03577 0.120685 9.28035 0.0172534 9.5398 0.00197221C9.79924 -0.013309 10.0557 0.0606099 10.2611 0.209861L10.3615 0.292861Z" fill="#899CA8"/>
</svg>

  )
}

export function FAQs(){
  return(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.16998 22.1094C7.42998 22.2494 7.72 22.3194 8 22.3194C8.34 22.3194 8.67997 22.2195 8.96997 22.0295L13.23 19.1894H17C20.44 19.1894 22.75 16.8794 22.75 13.4394V7.43945C22.75 3.99945 20.44 1.68945 17 1.68945H7C3.56 1.68945 1.25 3.99945 1.25 7.43945V13.4394C1.25 16.6194 3.23 18.8395 6.25 19.1495V20.5694C6.25 21.2094 6.59998 21.8094 7.16998 22.1094Z" fill="#899CA8"/>
<path d="M11.9998 12.1094C11.5898 12.1094 11.2498 11.7694 11.2498 11.3594V11.1494C11.2498 9.98941 12.0998 9.4194 12.4198 9.1994C12.7898 8.9494 12.9098 8.77941 12.9098 8.51941C12.9098 8.01941 12.4998 7.60938 11.9998 7.60938C11.4998 7.60938 11.0898 8.01941 11.0898 8.51941C11.0898 8.92941 10.7498 9.26941 10.3398 9.26941C9.92984 9.26941 9.58984 8.92941 9.58984 8.51941C9.58984 7.18941 10.6698 6.10938 11.9998 6.10938C13.3298 6.10938 14.4098 7.18941 14.4098 8.51941C14.4098 9.65941 13.5698 10.2294 13.2598 10.4394C12.8698 10.6994 12.7498 10.8694 12.7498 11.1494V11.3594C12.7498 11.7794 12.4098 12.1094 11.9998 12.1094Z" fill="white"/>
<path d="M12 14.5996C11.58 14.5996 11.25 14.2596 11.25 13.8496C11.25 13.4396 11.59 13.0996 12 13.0996C12.41 13.0996 12.75 13.4396 12.75 13.8496C12.75 14.2596 12.42 14.5996 12 14.5996Z" fill="white"/>
</svg>

  )
}

export function DeleteBin(){
  return(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21 6H3V9C4.10457 9 5 9.89543 5 11V15C5 17.8284 5 19.2426 5.87868 20.1213C6.75736 21 8.17157 21 11 21H13C15.8284 21 17.2426 21 18.1213 20.1213C19 19.2426 19 17.8284 19 15V11C19 9.89543 19.8954 9 21 9V6ZM10.5 11C10.5 10.4477 10.0523 10 9.5 10C8.94772 10 8.5 10.4477 8.5 11V16C8.5 16.5523 8.94772 17 9.5 17C10.0523 17 10.5 16.5523 10.5 16V11ZM15.5 11C15.5 10.4477 15.0523 10 14.5 10C13.9477 10 13.5 10.4477 13.5 11V16C13.5 16.5523 13.9477 17 14.5 17C15.0523 17 15.5 16.5523 15.5 16V11Z" fill="#FF5A4E"/>
<path d="M10.0681 3.37059C10.1821 3.26427 10.4332 3.17033 10.7825 3.10332C11.1318 3.03632 11.5597 3 12 3C12.4403 3 12.8682 3.03632 13.2175 3.10332C13.5668 3.17033 13.8179 3.26427 13.9319 3.37059" stroke="#FF5A4E" stroke-width="2" stroke-linecap="round"/>
</svg>

  )
}

export function VerticalDot(){
  return(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z" fill="#707581"/>
<path d="M4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10Z" fill="#707581"/>
<path d="M20 10C21.1046 10 22 10.8954 22 12C22 13.1046 21.1046 14 20 14C18.8954 14 18 13.1046 18 12C18 10.8954 18.8954 10 20 10Z" fill="#707581"/>
</svg>
  )
}